import { fork } from "redux-saga/effects";

import { StatisticsApi, UsersApi } from "services/http";
import { getFetchSaga, removeFetchSaga } from "store/commonSagas";
import {
  getUserDeletionInfoFailure,
  getUserDeletionInfoRequest,
  getUserDeletionInfoSuccess,
  getUsersListFailure,
  getUsersListRequest,
  getUsersListSuccess,
  getUserStatisticsFailure,
  getUserStatisticsRequest,
  getUserStatisticsSuccess,
  removeUserFailure,
  removeUserRequest,
  removeUserSuccess,
} from "store/slices/usersSlice";

const watchGetList = getFetchSaga(getUsersListRequest.type, UsersApi.getList, getUsersListSuccess, getUsersListFailure);

const watchRemove = removeFetchSaga(removeUserRequest.type, UsersApi.remove, removeUserSuccess, removeUserFailure);

const watchGetStatistics = getFetchSaga(
  getUserStatisticsRequest.type,
  StatisticsApi.getUserStatistics,
  getUserStatisticsSuccess,
  getUserStatisticsFailure,
);

const watchGetDeletionInfo = getFetchSaga(
  getUserDeletionInfoRequest.type,
  UsersApi.getDeletionInfo,
  getUserDeletionInfoSuccess,
  getUserDeletionInfoFailure,
);

export const userWatchers = [
  fork(watchGetList),
  fork(watchRemove),
  fork(watchGetStatistics),
  fork(watchGetDeletionInfo),
];
